// Vendors
import $ from 'jquery';

function modalInUrl(modalId) {
  let currentURL = window.location.href;
  let addedId = '#' + modalId;
  let newURL = currentURL + addedId;
  window.history.pushState({}, '', newURL);
}

function removeIdFromUrl(modalId) {
  let currentURL = window.location.href;
  let removedId = '#' + modalId;
  let newURL = currentURL.split(removedId)[0];
  window.history.pushState({}, '', newURL);
}

$(document).ready(function () {
  // open modal if page url has modal id
  $('.modal').each(function () {
    const modalId = `#${$(this).attr('id')}`;
    if (window.location.href.indexOf(modalId) !== -1) {
      $(modalId).addClass('modal--visible');
    }
  });

  // on video modal click add id at the end of the url
  $('.video-library article').on('click', (event) => {
    let modalAttr = $(event.currentTarget).attr('data-modal-show');
    modalInUrl(modalAttr);
  });

  // remove id from url when modal is closed
  $('.modal').on('click', (event) => {
    let modalId = $(event.currentTarget).attr('id');
    removeIdFromUrl(modalId);
  });

  $('.modal__close').on('click', (event) => {
    let modalId = $(event.currentTarget).attr('data-modal-id');
    removeIdFromUrl(modalId);
  });
});
